import type { PanelSalesInquiryRowDto, SalesInquiryStatus } from '@icebreaker/shared';
import type { Translator } from '@icebreaker/shared/i18n';
import type { TagVariant } from '@icebreaker/ui';

/**
 * Durum → rozet tonu (referans `ST` tablosu): Yeni birincil, İletişime
 * geçildi bekleme, Kazanıldı başarı, Kaybedildi nötr, Spam çerçeveli.
 */
export const SALES_STATUS_VARIANT: Readonly<Record<SalesInquiryStatus, TagVariant>> = {
  new: 'accent',
  contacted: 'warning',
  won: 'success',
  lost: 'neutral',
  spam: 'outline',
};

/**
 * Takvim günü (`YYYY-MM-DD`) saat dilimi kaymadan biçimlenmek üzere öğle
 * anına çevrilir: gece yarısı UTC'de batıdaki tarayıcı bir önceki güne düşerdi.
 */
export function calendarDayInstant(day: string): string {
  return `${day}T12:00:00.000Z`;
}

/** Referansın tarih dili: TR `12.10.2026`, EN `12 Oct 2026`. */
export function numericDateOptions(locale: string): Intl.DateTimeFormatOptions {
  return locale === 'tr'
    ? { day: '2-digit', month: '2-digit', year: 'numeric' }
    : { dateStyle: 'medium' };
}

/** Tarih + saat: TR `14.09.2026 10:42`, EN `14 Sep 2026, 10:42`. */
export function numericDateTimeOptions(locale: string): Intl.DateTimeFormatOptions {
  return locale === 'tr'
    ? { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }
    : { dateStyle: 'medium', timeStyle: 'short' };
}

/**
 * Listenin kısa tarihi (referans `01 Eyl`): yıl YALNIZ bu yıl için düşer.
 * Geçen yılın adayı yılsız yazılırsa bu yılınkiyle karışır (`01 Eyl 2025`).
 * Yıl tarayıcının yerel takvimine göre karşılaştırılır, biçimleyici de öyle yazar.
 */
export function shortDateOptions(
  iso: string,
  nowMs: number = Date.now(),
): Intl.DateTimeFormatOptions {
  const sameYear = new Date(iso).getFullYear() === new Date(nowMs).getFullYear();
  return sameYear
    ? { day: '2-digit', month: 'short' }
    : { day: '2-digit', month: 'short', year: 'numeric' };
}

/**
 * Satırın türü (B-21): satış başvurusunda etkinlik türü, kurum talebinde
 * konunun talep adı ("Kredi talebi", kredi yüklemede paket adıyla). Kurum etiketi ayrı
 * kolondadır (`organization`).
 */
export function inquiryKindLabel(
  t: Translator,
  row: Pick<PanelSalesInquiryRowDto, 'eventType' | 'topic' | 'creditPackage'>,
): string {
  if (row.topic) {
    const topic = t.t(`admin.sales.topics.${row.topic}`);
    return row.creditPackage
      ? `${topic} · ${t.t(`admin.sales.packages.${row.creditPackage}`)}`
      : topic;
  }
  return row.eventType ? t.t(`admin.sales.eventTypes.${row.eventType}`) : '';
}
